<template>
  <div class="">
    <div
      class="modal fade"
      id="show_message_register"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l">
          <div class="modal-body img-info-lubricator">
            <div class="boton">
              <button
                  type="button"
                  class="close close-info-l"
                  data-dismiss="modal"
                  aria-label="Close"
              >
                X
              </button>
            </div>
            <div class="row justify-content-center" title="Popup bienvenida havoline moto club" alt="Popup bienvenida havoline moto club">
              <div class="col-12">
                <p class="title-info-l ">
                  ¡BIENVENIDO A<br/>
                  HAVOLINE MOTOCLUB!
                </p>
              </div>
              <div
                  class="col-12 col-md-12 col-lg-12 col-xl-11 col-sm-12"
                  style="text-align: center"
              >
                <p class="subtitle-info-l">
                  Día a día mejoramos este Club para que tengas una mejor experiencia.
                  <br/><br/>
                  Si eres Mecánico, dile a tu Distribuidor Autorizado Máster Chevron de la zona que te registre.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modalRegister",
  data(){
    return{
    }
  }
}
</script>


<style scope>
.content-login-l {
  padding-left: 5%;
  padding-top: 16%;
  padding-bottom: 15%;
  height: 100%;
}

.small-register {
  font-family: "GothamBoldItalic" !important;
}

.club-l {
  font-size: 55px;
  font-family: "Gotham-UltraItalic";
  text-align: left;
}

.ingresa-l {
  font-size: 23px;
  text-align: left;
  font-family: "GothamBookItalic";
}

.t-c {
  text-align: center;
}
label.text-login {
  margin-bottom: 0rem;
  font-family: "GothamBoldItalic";
  font-size: 15px;
}

.title-info-l {
  font-size: 40px;
  color: #fdd200;
  font-family: "Gotham-UltraItalic";
}

.subtitle-info-l {
  font-size: 27px;
  color: #fff;
  font-family: "GothamBoldItalic";
}

.modal-info-l {
  border-radius: 25px !important;
}

.close-info-l {
  font-weight: bold;
  color: red;
}

/* BOTÓN */

.boton {
  width: 30px;
  height: 30px;
  background-color: #fff;
  margin: 0px;
  padding: 4px 7px 2px 3px;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  font-size: 11px;
  line-height: 32px;
  text-transform: uppercase;
  float: right;
}
.boton:hover {
  background-color: #fff !important;
  color: #e9434c !important;
}

.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}

.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}

a.reset-password {
  cursor: pointer !important;
  color: white;
}

a.reset-password:hover {
  color: #b3b3b3 !important;
}

.color-input-fixed-text{
  background-color: #ffffff00 !important;
  color: #fff !important;
  height: 30px !important;
  font-size: 13px;
}

.color-input-fixed-icon{
  background-color: #ffffff00 !important;
  color: white;
  height: 30px !important;
}

.color-input-fixed-text::placeholder {
  color: white !important;
}


.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}

.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}

.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}

.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}

.color-input::placeholder {
  color: white !important;
}

.color-option {
  color: black !important;
}

.color-option:active {
  background-color: crimson !important;
}

.icon-disable {
  color: #676565 !important;
}

.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}

.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}

.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}
.img-info-lubricator {
  border-radius: 22px;
  background-image: url("../assets/img/pop-up-mecanico-register.png");
  background-position: center;
  background-size: cover;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBoldItalic";
  src: url("../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBookItalic";
  src: url("../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */

@media (max-width: 1200px) {
  .img-info-lubricator {
    width: 100% !important;
  }
  .content-login-l {
    height: 100%;
  }

  .title-info-l {
    padding: 0px;
    font-size: 32px;
  }

  .subtitle-info-l {
    padding: 0px;
    font-size: 23px;
  }

  .close-info-l {
    font-size: 16px !important;
  }

  .boton {
    width: 25px;
    height: 25px;
    padding: 6px 6px 5px 10px;
    font-size: 16px !important;
  }
}

/* TABLET */

@media (max-width: 1023px) {
  .img-info-lubricator {
    width: 100% !important;
  }
  .content-login-l {
    height: 100%;
  }
  #img-text {
    width: 420px;
  }
  .padding-t {
    padding-top: 5%;
    padding-bottom: 8%;
  }

  .title-info-l {
    padding: 0px;
    font-size: 25px;
  }

  .subtitle-info-l {
    padding: 0px;
    font-size: 20px;
  }

  .close-info-l {
    font-size: 16px !important;
  }

  .boton {
    width: 25px;
    height: 25px;
    padding: 6px 6px 5px 10px;
    font-size: 16px !important;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  #content1-login-l{
    background-position: right;
  }
  .img-info-lubricator {
    width: 100% !important;
  }
  .p-row {
    padding-bottom: 1% !important;
  }
  #img-text {
    width: 320px;
  }
  .content-login-l {
    padding-left: 0%;
    padding-top: 40%;
    padding-bottom: 30%;
  }
  .club-l {
    font-size: 40px;
    text-align: left;
  }

  .ingresa-l {
    font-size: 18px;
    text-align: left;
  }

  .margin-btn {
    margin-bottom: 35%;
  }

  .title-info-l {
    padding: 0px;
    font-size: 18px;
  }

  .subtitle-info-l {
    padding: 0px;
    font-size: 14px;
  }

  .close-info-l {
    font-size: 16px !important;
  }

  .boton {
    width: 20px;
    height: 20px;
    padding: 4px 5px 2px 3px;
    font-size: 16px !important;
  }
}
</style>